import React, { FC } from "react";
import {
  EuiButtonIcon,
  EuiFlexGroup,
  EuiFlexItem,
  EuiPanel,
  EuiTextArea,
} from "@elastic/eui";

export interface IProductGroupServicePanelProps {
  service: { index: number; text: string };
  onEditServiceText: (index: number, text: string) => void;
  onMoveServiceUp: (index: number) => void;
  onMoveServiceDown: (index: number) => void;
  onRemoveService: (index: number) => void;
}

const ProductGroupServicePanel: FC<IProductGroupServicePanelProps> = ({
  service,
  onEditServiceText,
  onMoveServiceUp,
  onMoveServiceDown,
  onRemoveService,
}) => {
  const onEditServiceChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onEditServiceText(service.index, e.target.value);
  };

  const onMoveServiceUpClicked = () => {
    onMoveServiceUp(service.index);
  };

  const onMoveServiceDownClicked = () => {
    onMoveServiceDown(service.index);
  };

  const onRemoveServiceClicked = () => {
    onRemoveService(service.index);
  };

  return (
    <EuiPanel hasShadow={false} hasBorder={true}>
      <EuiFlexGroup justifyContent="spaceBetween">
        <EuiFlexItem grow={true}>
          <EuiTextArea value={service.text} onChange={onEditServiceChange} />
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
          <EuiFlexGroup direction="column" alignItems="center">
            <EuiFlexItem>
              <EuiButtonIcon
                id="close"
                iconType="cross"
                onClick={onRemoveServiceClicked}
              />
            </EuiFlexItem>
            <EuiFlexItem>
              <EuiButtonIcon
                id="up"
                iconType="arrowUp"
                onClick={onMoveServiceUpClicked}
              />
            </EuiFlexItem>
            <EuiFlexItem>
              <EuiButtonIcon
                id="down"
                iconType="arrowDown"
                onClick={onMoveServiceDownClicked}
              />
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
      </EuiFlexGroup>
    </EuiPanel>
  );
};

export default ProductGroupServicePanel;
